module.exports = __webpack_public_path__ + "static/media/dazzshop1.c228f70d.png";